import React, { useEffect, useMemo, useState } from "react";
import Buttons from "../../components/ui/button/Buttons";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { usePeerReviewerServiceContext, validateRequirementFiles, validateSectionBMinimumCriteria, validateSections } from "./ServiceContext";
import { useLazyGetSelfEvalutionIdByAppIdQuery } from "../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useProcessForCretificateGroupingMutation, useRejectSelfEvalutionApplicationByCaseOfficerMutation, useReturnApplicationToCaseOfficerByPeerReviewerMutation, useSaveSelfEvalutionFormInfomationByCaseOfficerMutation, useSendClarificationForExistingRequirementMutation, useLazyGetPeerReviewEvaluationDetailsByIdQuery, useLazyGetMinimumCriteriaForServiceByApplicationIdQuery, useSavePeerReviewerEvaluationDetailsMutation } from "../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import ToastService from "../../services/toastService/ToastService";
import SwalAlert from "../../services/swalService/SwalService";
import SectionA from "./components/SectionA/SectionA"
import SectionB from "./components/SectionB/SectionB";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../app/services/productAndService/productAndServiceApi";
import { useUpdateApplicationStatusOnPeerReviewerReturnMutation } from "../../app/services/CertificateGrouping/certificateGroupingApi";



const ServicePeerReviewerForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, dispatch } = usePeerReviewerServiceContext();
  const sectionCCount = state.sectionCCount;
  const sectionCFileCount = state.sectionCFileCount;
  const { error, success, confirm } = SwalAlert();
  const routeMap = {
    10: "CertificateGroupingWIthRatingReview",
    11: "CertificateGroupingWithoutRatingReview",
  };

  const [isSendClarification, setIsSendClarification] = useState(false);
  const [peerReviewerComment, setPeerReviewerComment] = useState("")
  const [isRetrun, setIsReturn] = useState(false);

  const [approverReviewerComment, setApproverReviewerComment] = useState("")
  const [isProcessing, setIsProcessing] = useState(false);
  const [tempId, setTempId] = useState(null);
  const [isReject, setIsReject] = useState(false);
  const [rejectReasonOptions, setRejectReasonOptions] = useState([]);
  const [rejectData, setRejectData] = useState({
    reason: null,
    comment: "",
  });
  const [rejectErrors, setRejectErrors] = useState({
    reason: "",
    comment: "",
  });
  const [getSelfEvaluationId, { isLoading: selfEvaluationIdIsLoading, isSuccess: selfEvaluationIdIsSuccess, data: selfEvaluationIdData, },] = useLazyGetSelfEvalutionIdByAppIdQuery();
  const [rejectSelfEvalutionApplication, { isLoading: rejectApplicationIsLoading, isSuccess: rejectApplicationIsSuccess, data: rejectApplicationData }] = useRejectSelfEvalutionApplicationByCaseOfficerMutation();
  const [SendClarificationForExistingRequirement, { isLoading: SendClarificationForExistingRequirementLoading, isSuccess: SendClarificationForExistingRequirementSuccess, data: SendClarificationForExistingRequirementData }] = useSendClarificationForExistingRequirementMutation();
  const [ProcessForCretificateGrouping, { isLoading: ProcessForCretificateGroupingLoading, isSuccess: ProcessForCretificateGroupingSuccess, data: ProcessForCretificateGroupingData }] = useProcessForCretificateGroupingMutation();
  const [getPeerReviewEvaluationDetailsById, { isLoading: getPeerReviewEvaluationDetailsByIdLoading, isSuccess: getPeerReviewEvaluationDetailsByIdSuccess, data: getPeerReviewEvaluationDetailsByIdData, },] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();
  const [getDropDownsForProductsAndServices, { isLoading: dropDownsLoading, isSuccess: dropDownsSuccess, data: dropDownsData }] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [getMinimumCriteriaForService, { data: minimumCriteria, isLoading: minimumCriteriaLoading }] = useLazyGetMinimumCriteriaForServiceByApplicationIdQuery();
  const [savePeerReviewerEvaluationDetails, { isLoading: savePeerReviewerEvaluationDetailsLoading, isSuccess: savePeerReviewerEvaluationDetailsSuccess, data: savePeerReviewerEvaluationDetailsData, },] = useSavePeerReviewerEvaluationDetailsMutation();
  const [returnToCaseOfficer, { isLoading: returnToCaseOfficeLoading, isSuccess: returnToCaseOfficerSuccess, data: returnToCaseOfficerData, },] = useReturnApplicationToCaseOfficerByPeerReviewerMutation();
  const [updateApplicationStatusOnPeerReviewerReturn, { isLoading: updateStatusOnReturnLoading, isSuccess: updateStatusOnReturnLoadingSuccess, data: updateStatusOnReturnLoadingData }] = useUpdateApplicationStatusOnPeerReviewerReturnMutation();





  useEffect(() => {
    if (dropDownsSuccess && dropDownsData) {
      setRejectReasonOptions(dropDownsData.filter((item) => item?.dropdownName === "Application Discontinue")?.map((item) => ({
        value: item.id,
        label: item.name,
      })) || []);
    }
  }, [dropDownsSuccess, dropDownsData, dropDownsLoading]);

  //  may be use for section 2

  const hasPendingClarification = useMemo(() => {
    const sections = ["A", "B"];
    return sections.some((section) =>
      Object.values(state?.sections?.[section]?.requirements || {}).some(
        (req) => req?.status != null && req?.status === "Pending Clarification"
      )
    );
  }, [state?.sections?.A?.requirements, state?.sections?.B?.requirements]);

  const handleSaveForm = () => {
    debugger;
    let { sections } = state;
    let sGBPProductInformationId = decryptAESID(id, false);
    const payload = {
      SGBPProductInformationId: sGBPProductInformationId || null,
      PeerReviewerComment: peerReviewerComment,
      SavePeerReviwerInternalCommentListRequest: [],
    };

    Object.entries(sections).forEach(([sectionKey, sectionValue]) => {
      Object.entries(sectionValue.requirements || {}).forEach(
        ([requirementId, requirementData]) => {

          const obj = {
            SGBPProductInformationId: sGBPProductInformationId,
            SelfEvaluationRequirementId: requirementData?.selfEvalRequirementId,
            PeerReviewerInternalComment: requirementData?.peerReviewerComments,
          };

          if (obj.SGBPProductInformationId != null && obj.SelfEvaluationRequirementId != null && obj.PeerReviewerInternalComment != null) {
            payload.SavePeerReviwerInternalCommentListRequest.push(obj);
          }
        }
      );
    });
    if (payload) {
      savePeerReviewerEvaluationDetails(payload)
    }
  }
  const handleReject = () => {
    confirm('Reject?', 'Are you sure you want to reject?', 'Reject', 'Cancel').then((confirmed) => {
      if (confirmed) {
        // handleRejectApplication();
        setIsReject(true);
      }
    });
  };



  const handleNext = async () => {
    setIsReturn(true);
    await handleSaveForm();
    const route = routeMap[tempId];
    // navigate(`/CertificateGrouping/${id}`);
    navigate(route ? `/${route}/${id}` : `/CertificateGrouping/${id}`);
  };




  // ─── BUILD CERTIFICATE GROUPING REQUEST (per brand, min Rating & min Tick across all Section B requirements)
  const buildCertificateGroupingRequest = (applicationId) => {
    const fieldsObj = state.sections?.B?.fields || {};
    const fieldListB = state.sections?.B?.fieldList || [];
    // additionalFieldId -> { isTickRating, isTextBox }
    const fieldTypeMap = {};
    fieldListB.forEach((f) => {
      fieldTypeMap[f.sgbpAdditionalFieldInputId] = {
        isTickRating: f.isTickRating,
        isTextBox: f.isTextBox,
      };
    });

    // brandKey -> { brandId, ticks: [], textValue }
    const brandMap = {};
    fieldListB.forEach((fieldDef) => {
      const rawFieldId = fieldDef.sgbpAdditionalFieldInputId;
      const type = fieldTypeMap[rawFieldId];
      if (!type) return;
      Object.values(fieldsObj)
        .filter((f) => f.additionalFieldId === rawFieldId)
        .forEach((field) => {
          // Group per brand when a brand exists, otherwise use a single "no-brand" bucket
          const brandKey = field.brandItemId ?? "no-brand";
          if (!brandMap[brandKey]) {
            brandMap[brandKey] = {
              brandId: field.brandItemId ?? null,
              ticks: [],
              textValue: null,
            };
          }

          // --- Tick rating: only parse numerically for tick fields
          if (type.isTickRating) {
            const numValue = Number(field.value);
            if (!Number.isNaN(numValue)) {
              brandMap[brandKey].ticks.push(numValue);
            }
          }

          // --- Text box: keep the first non-null/non-empty value; if all are null, stays null
          if (type.isTextBox && brandMap[brandKey].textValue == null) {
            const value = field.value;
            if (value !== null && value !== undefined && value !== "") {
              brandMap[brandKey].textValue = value;
            }
          }
        });
    });
    const BrandIdListtRequest = Object.values(brandMap).map(
      ({ brandId, ticks, textValue }) => {
        // Minimum tick rating for this brand (or the no-brand group)
        const minBrandRating = ticks.length ? Math.min(...ticks) : "";

        let rating;
        if (minBrandRating !== null && sectionCCount != null) {
          rating = Math.min(minBrandRating, sectionCCount);
        } else {
          rating = minBrandRating ?? sectionCCount ?? null;
        }

        return {
          BrandId: brandId !== null ? Number(brandId) : null,
          Rating: rating,
          TextValue: textValue || "",
        };
      }
    );

    return {
      SGBPSAppplicationId: applicationId,
      BrandIdListtRequest,
    };
  };


  useEffect(() => {
    const editID = decryptAESID(id, false);
    if (editID > 0) {
      getDropDownsForProductsAndServices();
      getSelfEvaluationId(editID);
      getPeerReviewEvaluationDetailsById(editID)
      getMinimumCriteriaForService(editID);
    }
  }, [id]);

  useEffect(() => {
    if (!selfEvaluationIdIsLoading && selfEvaluationIdIsSuccess) {
      setTempId(selfEvaluationIdData?.templateId);
      ["A", "B"].forEach((section) => {
        dispatch({
          type: "SET_SELF_EVALUATION_ID",
          section,
          selfEvaluationId: selfEvaluationIdData?.selfEvaluationId || null,
          applicationStatus: selfEvaluationIdData?.statusName || null,
          isApplicationReturned: selfEvaluationIdData?.isApplicationReturned || false,
        });
      });
    }
  }, [selfEvaluationIdIsSuccess, selfEvaluationIdData, selfEvaluationIdIsLoading]);


  useEffect(() => {
    if (!SendClarificationForExistingRequirementLoading && SendClarificationForExistingRequirementSuccess && SendClarificationForExistingRequirementData) {
      if (!SendClarificationForExistingRequirementData.hasError) {
        ToastService.success("Clarification sent Successfully");
        handleBack();
      } else {
        ToastService.error(SendClarificationForExistingRequirementData.errorMessage);
      }
    }
  }, [SendClarificationForExistingRequirementLoading, SendClarificationForExistingRequirementSuccess, SendClarificationForExistingRequirementData]);

  useEffect(() => {
    if (!minimumCriteriaLoading && minimumCriteria) {
      const value = Number(minimumCriteria?.minimumCriteria) || 0;
      dispatch({ type: "SET_SECTION_B_MIN_CRITERIA", value });
    }
  }, [minimumCriteriaLoading, minimumCriteria]);

  useEffect(() => {
    if (!rejectApplicationIsLoading && rejectApplicationIsSuccess && rejectApplicationData) {

      if (!rejectApplicationData.hasError) {
        ToastService.success("Application has been rejected.")
        closeClarificationModal();
        handleBack();
      } else {
        ToastService.error(rejectApplicationData.errorMessage)
      }
    }
  }, [rejectApplicationIsLoading, rejectApplicationIsSuccess, rejectApplicationData]);

  useEffect(() => {
    if (!ProcessForCretificateGroupingLoading && ProcessForCretificateGroupingSuccess && ProcessForCretificateGroupingData) {
      ToastService.success("Certificate Grouping Processed Successfully");
      setIsProcessing(false);
      const route = routeMap[tempId];
      // navigate(`/CertificateGroupingRequest/${id}`);
      navigate(route ? `/${route}/${id}` : `/CertificateGroupingRequest/${id}`);
    }
  }, [ProcessForCretificateGroupingLoading, ProcessForCretificateGroupingSuccess, ProcessForCretificateGroupingData]);

  useEffect(() => {
    if (!savePeerReviewerEvaluationDetailsLoading && savePeerReviewerEvaluationDetailsSuccess && savePeerReviewerEvaluationDetailsData) {
      if (!savePeerReviewerEvaluationDetailsData.hasError) {
        !isRetrun && ToastService.success("Details updated Successfully.");
      } else {
        ToastService.error(savePeerReviewerEvaluationDetailsData.errorMessage);
      }
      setIsReturn(false)
    }
  }, [savePeerReviewerEvaluationDetailsLoading, savePeerReviewerEvaluationDetailsSuccess, savePeerReviewerEvaluationDetailsData]);

  useEffect(() => {
    if (!getPeerReviewEvaluationDetailsByIdLoading && getPeerReviewEvaluationDetailsByIdSuccess && getPeerReviewEvaluationDetailsByIdData) {
      setPeerReviewerComment(getPeerReviewEvaluationDetailsByIdData?.peerReviewerComment)
      setApproverReviewerComment(getPeerReviewEvaluationDetailsByIdData?.finalApproverComment)
    }
  }, [getPeerReviewEvaluationDetailsByIdLoading, getPeerReviewEvaluationDetailsByIdSuccess, getPeerReviewEvaluationDetailsByIdData]);

  useEffect(() => {
    if (!returnToCaseOfficeLoading && returnToCaseOfficerSuccess && returnToCaseOfficerData) {
      if (!returnToCaseOfficerData.hasError) {
        ToastService.success("Application Returned to Case Officer");
        handleBack();
      } else {
        ToastService.error(returnToCaseOfficerData.errorMessage);
      }
    }
  }, [returnToCaseOfficeLoading, returnToCaseOfficerSuccess, returnToCaseOfficerData]);

  const handleBack = () => {
    navigate("/viewApplicationTaskList")
  }
    ;

  const closeClarificationModal = () => {
    setIsSendClarification(false);
    setIsReject(false);
    setRejectErrors({
      reason: "",
      comment: "",
    });
    setRejectData({
      reason: null,
      comment: "",
    });
  };

  const handleReturn = () => {
    confirm('Return?', 'Are you sure you want to return?', 'Return', 'Cancel').then((confirmed) => {
      if (confirmed) {
        handleReturnApplication();
      }
    });
  };

  const handleReturnApplication = () => {
    setIsReturn(true);
    let req = {}
    req.sGBPProductInformationId = decryptAESID(id);
    req.peerReviewerComment = peerReviewerComment
    req.FinalApproverComment = approverReviewerComment
    if (req) {
      handleSaveForm();
      returnToCaseOfficer(req)
      updateApplicationStatusOnPeerReviewerReturn({ SGBPProductInformationId: decryptAESID(id) });
    }
  };


  return (
    <div className="self-evaluation-page">
      {/* SECTION*/}
      <SectionA />
      <SectionB />
      {/* <SectionC /> */}
      <div className="form-actions">
        <Buttons buttonText="Back" buttonTypeClassName="black-btn btn outline-btn " onClick={handleBack} />
        <Buttons buttonText="Save" buttonTypeClassName="submit-btn btn outline-btn" onClick={handleSaveForm} isLoading={!isRetrun && savePeerReviewerEvaluationDetailsLoading} isDisable={savePeerReviewerEvaluationDetailsLoading} />
        <Buttons buttonText="Return" buttonTypeClassName="reject  btn" onClick={handleReturn} isLoading={returnToCaseOfficeLoading || updateStatusOnReturnLoading} isDisable={returnToCaseOfficeLoading || updateStatusOnReturnLoading} />
        <Buttons buttonText="Next" buttonTypeClassName="submit-btn btn outline-btn" onClick={handleNext} />
        {/* <Button className="submit-btn btn outline-btn " disabled={hasAnyStatus}> Process</Button> */}
      </div>

    </div>
  );
};

export default ServicePeerReviewerForm;
